<template>
  <form @submit.stop.prevent="markPaid">
    <div class="my-4">
      <label>Payment Method</label>
      <multiselect v-model="order.paymentType" :options="paymentMethods.objects" :class="{
                        'is-invalid': v$.order.paymentType.$error,
                  }" class="multiselect-height-3" placeholder="Select one" label="paymentMethodName" track-by="paymentMethodName">
      </multiselect>
      <p
          v-for="error in v$.order.paymentType.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-4">
      <label>Payment Received Date</label>
      <DatePicker
        v-model="order.paymentReceivedDate"
        :disabled-dates="disabledDates"
        format="yyyy-MM-dd"
        :class="{
          'is-invalid': v$.order.paymentReceivedDate.$error,
        }"
      ></DatePicker>
      <small class="form-text text-muted">
        Date when payment is received.
      </small>
      <p
          v-for="error in v$.order.paymentReceivedDate.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-4">
      <label>Payment Ref</label>
      <input
          v-model="order.paymentRef"
          type="text"
          class="form-control"
      />
    </div>
    <div class="my-4">
      <label>Payment Type</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" value="Full" name="flexRadioDefault" id="flexRadioDefault1" :checked="order.paymentFull === 'Full'" @change="paymentIsFull($event)">
        <label class="form-check-label" for="flexRadioDefault1">
          Full Payment
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" value="Partial" name="flexRadioDefault" id="flexRadioDefault2" :checked="order.paymentFull === 'Partial'" @change="paymentIsFull($event)">
        <label class="form-check-label" for="flexRadioDefault2">
          Partial Payment
        </label>
      </div>
    </div>
    <div v-if="order.paymentFull === 'Partial'" class="my-4">
      <label>Payment Amount (Balance Due: Ksh {{ orderBalanceDue | formatNumber }})</label>
      <input
          v-model="order.amountPaid"
          :max="orderBalanceDue"
          min=1
          type="number"
          class="form-control"
      />
    </div>
    <div v-for="(error, index) in ordersErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle" v-if="order.paymentFull === 'Full' || order.amountPaid <= orderBalanceDue">
      <b-button variant="primary" size="lg" class="py-2 text-white" disabled v-if="ordersLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-2 text-white" type="submit" v-else>Make Payment</b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapGetters} from "vuex";
import Multiselect from "vue-multiselect";
import {ALL_PAYMENT_METHODS} from "@/gql/orders";
import moment from 'moment'
import DatePicker from '@sum.cumo/vue-datepicker'
import '@sum.cumo/vue-datepicker/dist/Datepicker.css'

export default {
  name: "mark-as-paid-modal",
  components: {Multiselect, DatePicker},
  setup () {
    return { v$: useVuelidate() }
  },
  props: {
    orderBalanceDue: { type: Number }
  },
  data() {
    return {
      order: {
        paymentType: '',
        paymentRef: '',
        paymentFull: 'Full',
        amountPaid: '',
        paymentReceivedDate: '',
      },
      paymentMethods: {
        objects: []
      },
      disabledDates: {
        from: new Date(moment().format('YYYY-MM-DD')),
      },
    }
  },
  validations () {
    return {
      order: {
        paymentType: {required},
        paymentReceivedDate: {required}
      }
    }
  },
  apollo: {
    paymentMethods: {
      query: ALL_PAYMENT_METHODS,
      variables(){
        return{
          page: 1,
          perPage: 30
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      ordersErrors: 'orders/ordersErrors'
    }),
  },
  methods: {
    async markPaid() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      if (this.order.paymentFull === 'Partial'){
        const data = {
          paymentStatus: 40,
          ... this.order
        }
        this.$emit('markPaid', data)
      } else if (this.order.paymentFull === 'Full') {
        const data = {
          paymentStatus: 10,
          ... this.order
        }
        this.$emit('markPaid', data)
      }

      this.v$.$touch();
    },
    paymentIsFull(event){
      const val = event.target.value
      if (val === 'Full'){
        this.order.paymentFull = "Full"
      } else if (val === 'Partial') {
        this.order.paymentFull = "Partial"
      }

    }
  }
}
</script>

<style>
.vdp-datepicker input {
  border-radius: 5px;
}

.vdp-datepicker.is-invalid input {
  border-color: #D13704 !important;
}
</style>
